import React from "react";
import "./ListContentSlider.css";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

function ListContentSlider({ listContent }) {
  const settings = {
    arrows: false,
    dots: false, // Hide dots
    infinite: true, // Enable infinite loop
    speed: 1000, // Transition speed
    centerMode: true, // key to show partial next slide
    centerPadding: "40px", // adjust for spacing/peek
    slidesToShow: 3.5, // show two full and one half slide
    autoplay: true, // Enable autoplay
    autoplaySpeed: 3000, // Autoplay interval
    draggable: true, // Enable dragging
    swipeToSlide: true, // Allow swiping
    pauseOnHover: false, // Continue autoplay on hover
    responsive: [
      {
        breakpoint: 1350,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 1214,
        settings: {
          slidesToShow: 2.5,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1.5,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1.5,
        },
      },
    ],
  };
  return (
    <div className="homelistcontent-container">
      <Slider {...settings}>
        {listContent.map((content, index) => (
          <div key={content.id} className="listcontent-card">
            <p className="card-title">{content.title}</p>
            <div
              dangerouslySetInnerHTML={{
                __html: content.description,
              }}
            ></div>
          </div>
        ))}
      </Slider>
    </div>
  );
}

export default ListContentSlider;
